import { useTranslation } from 'react-i18next';
import LoginForm from '../forms/LoginForm';
import { FormPage } from './FormPage';

function LoginPage() {
  const { t } = useTranslation();
  return <FormPage title={t('login page title')} subtitle={t('login page description')} component={<LoginForm />} />;
}

export default LoginPage;
